import React from 'react'

const PlaneBadge = () => {
  return (
    <div className='w-4 h-4 absolute -top-1 -right-2 bg-orange rounded-full'>
      
    </div>
  )
}

export default PlaneBadge
